
import React from "react";

class WidgetInputView extends React.Component {

    constructor(props) 
	{
    	super(props);

    	this.state = {
    		inputValue:"",
			placeholder : props.placeholder,
			type :props.type,
			value : props.value
    	}

    	this.inputRef = "";
    	this.isCompositions = true;
    	this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount ()
	{
    	this.inputRef.addEventListener('compositionstart', function()
		{
			//非直接的文字输入时（键盘输入中文的拼音）
		    this.isCompositions = false;
		}.bind(this));

		this.inputRef.addEventListener('compositionend', function()
		{
			//直接输入文字后（键盘选择真实的汉字）
			this.isCompositions = true;
		}.bind(this));


		this.inputRef.addEventListener('input', function()
		{
			setTimeout(function() 
			{
                if( this.isCompositions && this.inputRef!==null && this.inputRef!==undefined ) 
				{
                	this.props.onChange({target:{value: this.inputRef.value}});
                }

            }.bind(this), 100);

		}.bind(this));

		this.setState({inputValue: this.props.value});
    }

    onChangeInput(e)
	{
		this.setState({inputValue: e.target.value});
    }

	componentWillReceiveProps (newProps)
	{
		if (newProps.value!==this.state.inputValue) 
		{
			this.setState({inputValue: newProps.value});
		}
		// if(this.props.flag){
		// 	this.setState({inputValue: undefined});
		// }
	
	}

    render() 
	{

		const { placeholder, className, type} = this.state;
    	return(
			<input 
				type={type}
				value={this.state.inputValue || "" }
				placeholder={placeholder} 
				onChange = {this.onChangeInput}
				onBlur = {this.props.onBlur}
				ref = { ref=>{ this.inputRef=ref}}
			/>
    		)
    }
}
export default WidgetInputView;